import type { SearchOption } from '../GlobalSearch.types'

export const DEFAULT_EMPTY_OPTION = '-'

export const getProductTypeIntl = (reason: MortgageReason): string => {
  return `productTypes.${STATUS_INTL[reason as keyof typeof STATUS_INTL]}`
}

const STATUS_INTL: Record<MortgageReason, string> = {
  REASON_FTB: 'firstTimeBuy',
  REASON_HOUSE_MOVE: 'houseMove',
  REASON_REMORTGAGE: 'remortgage',
  REASON_BTL: 'buyToLet',
  REASON_BTL_REMORTGAGE: 'buyToLetRemortgage',
  REASON_EQUITY_RELEASE: 'equityRelease',
  REASON_FURTHER_ADVANCE: 'furtherAdvance',
  REASON_BUSINESS_PROTECTION: 'businessProtection',
  REASON_PROTECTION: 'protection',
  INVALID_MORTGAGE_REASON: 'noReasonProvided',
  REASON_COMMERCIAL: 'commercial',
  REASON_BRIDGING: 'bridging',
  REASON_GENERAL_INSURANCE: 'homeInsurance',
}

/**
 * Generates a URL for a specific item (either client or individual case)
 */
export const getUrlForOption = (option: SearchOption) => {
  if (!option || !option.id) return ''

  if (option.doctype === 'client') return `/clients/${option.id}/overview`
  if (option.doctype === 'client_case') {
    // Solr uses composite IDs to prevent parent/child ID conflicts
    // Format: clientId_caseId - extract the case portion
    const caseId = option.id.split('_')[1]
    return `/cases/${caseId}/overview`
  }

  return ''
}

export const getName = (orgName: Maybe<string>, firstName: Maybe<string>, lastName: Maybe<string>) => {
  if (orgName) return orgName

  if (firstName && lastName) return `${firstName} ${lastName}`
  if (firstName) return firstName
  if (lastName) return lastName

  return DEFAULT_EMPTY_OPTION
}

export const getDisplayedProperty = (caseItem: SearchResultCase) => {
  const parts = [caseItem.address1, caseItem.town, caseItem.postcode].filter((part) => part && part.trim())

  return parts.length > 0 ? parts.join(', ') : DEFAULT_EMPTY_OPTION
}
